import PositiveNegativeWork from './containers/PositiveNegativeWork';
export default PositiveNegativeWork;